import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en_US from "../assets/locales/en_US/translation.json";
import it_IT from "../assets/locales/it_IT/translation.json";
i18n.use(initReactI18next).init({
    resources: {
        en_US: { translation: en_US },
        it_IT: { translation: it_IT },
    },
    fallbackLng: "it_IT",
    interpolation: {
        escapeValue: false,
    },
});
export default i18n;
